<template>
    <!-- 头部 -->
    <div class="head">
      <div class="heada">
        <a href="/" class="logo"><img src="~@/assets/img/logo.png" /></a>
        <div class="heada_one">
            <ul class="headb">
            <li :class="menuId==1?'active':''"><a href="/">首页</a></li>
            <li :class="menuId==2?'active':''"><a href="/profile">关于我们</a></li>
            <li :class="menuId==3?'active':''"><a href="/Mergence">资产布局</a></li>
            <li :class="menuId==4?'active':''"><a href="/invest">投资项目</a></li>
            <li :class="menuId==5?'active':''"><a href="/newscenter">新闻中心</a></li>
            <li :class="menuId==6?'active':''"><a href="/talent">加入我们</a></li>
          </ul>
          <div class="headc">
            <p>北京：北京市海淀区金源时代商务中心2号楼A座6层 </p>
            <p>香港：香港数码港道100号数码港一座8楼</p>
            <p>电话：(010)88503833<br/>传真：(010)88503824</p>
            <p style="font-size:12px;">版权所有©远景投资集团{{new Date().getFullYear()}} <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802023472" target="_blank" style="color:#3a3a3a;"><img src="~@/assets/img/icon-beian.png" style="display:inline-block;vertical-align:middle;margin-right:5px;margin-bottom:4px;"/>京公网安备 11010802023472号</a><a href="https://beian.miit.gov.cn" target="_blank" style="color:#3a3a3a;">京ICP备2023021352号-1</a><br/>
            </p>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
          menuId:1
        }
    },
    created () {

    },
    mounted () {
        
    },
    methods: {
    }
}
</script>


// WEBPACK FOOTER //
// src/views/pc/header.vue